<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-07-30 10:35:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-08-30 14:03:42
 * @Description: 合同——明细客户弹窗界面
 * @FilePath: \PCMS（链接9091）\src\views\ShareSystem\components\report\accountTable.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="dialog" width="1000px" :close-on-click-modal="false" >
          <span slot="title" class="dialog-title">核算主体</span>
          <div class="dialoginfo">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="accountTableData" tooltip-effect="dark" highlight-current-row @current-change="handleCurrentChange" @row-dblclick="rowDblclick">
                <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                <template v-for="(item, index) in accountTable">
                    <el-table-column v-if="item" :key="index"  :prop="item.prop" :label="item.label" :width="item.width" align="center" 
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="item.label == '序号'"> {{ scope.$index + 1 }} </span>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer"> 
            <el-button class="bottom_all_two" @click="reset">取 消</el-button>
            <el-button class="bottom_all" @click="submitDept" >确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import { getUserInfo } from "@/utils/auth.js";
import { cardLogin_HX,personOrgs_HX} from "@/views/ShareSystem/api/mainHx.js";
import { alterContractProfitCenter, } from "@/api/contractManageApi";
export default {
    components: {
    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        centerRow:{}
    },
    data(){
        return {
            tableParams:{
                page:1,
                pageSize:10,
                code:"",
                name:"",
                status:1,//只查询启用状态
            },
            accessToken:"",
            total:0,
            accountTableData:[],
            accountTable:[
                { label: "序号", width: "auto", prop: "index", status: true },
                { label: "员工编码", width: "auto", prop: "foreignId", status: true },
                { label: "员工姓名", width: "auto", prop: "userName", status: true },
                { label: "岗位", width: "auto", prop: "positionName", status: true },
                { label: "部门", width: "auto", prop: "deptName", status: true },
                { label: "公司", width: "auto", prop: "orgName", status: true },
            ],
            currentRow:{},
            form:{},
            ncNo:"",
            userName:"",
        }
    },
    watch:{
        
    },
    methods:{
      rowDblclick(row){
        this.currentRow = row;
        this.submitDept()
      },
        async initData(){
          let that = this
          let res = await cardLogin_HX({ idCard: "icps" })
            if (res.code == 1001) {
              let info = res.data;
              if (info && info.accessToken) {
                that.accessToken = info.accessToken
                let id = this.ncNo ? this.ncNo: getUserInfo().ncNo
                this.personOrgs_HX(that.accessToken,id );
              }
            }
        },
        setNcNo(data){
          this.ncNo = data.code
          this.userName = data.name
        },
        restParams(){
           this.tableParams={
                page:1,
                pageSize:10,
                code:"",
                name:"",
            }
            this.initData();
        },
        personOrgs_HX(accessToken,code) {
            let userName = this.userName ? this.userName: getUserInfo().userRealName
          personOrgs_HX({code: code,page:1,pageSize:999999},accessToken).then((res) => {
            if (res.code == 1001) {
              // 遍历每一条记录，添加 userName 属性
              res.data.records.forEach(record => {
                record.userName = userName;
              });
              this.accountTableData = res.data.records;
            }
          });
        },
        submitDept(){
            if(this.currentRow.length==0){
              this.$message.warning("请选中一条数据");
              return;
            }
            this.$emit("setAccount",this.currentRow)
            this.reset()
        },
        handleCurrentChange(val){
            this.currentRow = val;
        },
        reset() {
          this.$emit("resetAccount");
        },
        submitProfit(){
            if(Object.keys(this.currentRow).length === 0){
                this.$message.warning("请先选择一个客商！！！");
                return
            }else{
                let params = {
                  id: this.centerRow.id,
                  profitCenterName:this.currentRow.name,
                  profitCenterCode:this.currentRow.code,
                }
                alterContractProfitCenter( params).then(res => {
                    if (res.code == 1001) {
                        this.$message({ type: "success", message: res.codeMsg });
                        this.$emit('reset')
                    }
                })
            }
        },
        sizeChange(value) {
            this.tableParams.pageSize = value;
            this.initData();
        },
    }
}
</script>
<style lang="scss" scoped>
.addClass{
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}
.mr15{
  margin-right: 15px;
}
::v-deep .el-table__body tr.current-row > td {
    color: #fff;
    background: #00b85c !important;
}
</style>